// PREFILL BASE CLASSES.
document.addEventListener('DOMContentLoaded', () => {
    // add body.ready
    document.body.classList.add('ready')

    // switch body.is-mobile/desktop on resize
    const matchHandler = (e) => {
        document.body.classList.add(e.matches ? 'is-mobile' : 'is-desktop')
        document.body.classList.remove(e.matches ? 'is-desktop' : 'is-mobile')
    }
    const match = window.matchMedia('(max-width: 992px)')
    match.addEventListener('change', matchHandler)
    match.dispatchEvent(new Event('change'))
})
